//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import LandMap from "@/components/LandMap";
import { mapActions } from "vuex";
export default {
  name: "Base",
  data() {
    return {
      size: "",
      mapTopInfoOptions: {
        hasAll: true,
        isFilter: true,
        data: [],
        hasData: true,
      },
      villageInfo: "",
      markerInfo: {},
    };
  },
  components: { LandMap },
  filters: {},
  watch: {},
  created() {
    let { $businessId } = this.$route.query;
    this.getVillageById($businessId);
    this.changeShowTrajectory(false);
  },
  mounted() {},
  methods: {
    ...mapActions({
      changeShowTrajectory: "map/changeShowTrajectory",
    }),
    /**
     * @description: 获取村集体基础信息
     * @Author: yangsibo
     * @Date: 2022-06-07 15:30:35
     * @param {*} villageId 村集体id
     */
    async getVillageById(villageId) {
      try {
        let { data } = await this.$http.village.getVillageById({ villageId });
        this.villageInfo = data;
        if (data.centre) {
          let centre = data.centre ? data.centre.split(",") : [];
          this.markerInfo = {
            longitude: centre[0],
            latitude: centre[1],
          };
        }
      } catch (error) {}
    },
  },
};
